import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { theme } from 'antd';

import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { getPredefinedPowerScale } from '@/constants/getPredefinedPowerScale';
import { ComponentTierName, interestedPackageEnum, SensorsPackage } from '@/constants/enums';
import { checkInfoLockTierIsVisible } from '@/utils/util-functions';

import EPTierProtection from './common/EPTierProtection';
import EPTierInfoIcon from './common/EPTierInfoIcon';
import KPIBox from './KPIBox/KPIBox';
import Super from './Super';
import { useSpecificPowerKPI } from './MapKPI/MapKPI.utils';

const { useToken } = theme;

const SpecificPowerCard = observer(() => {
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { tvalue, tunit } = useMeasurement();
  const { token } = useToken();

  const specificPower = useSpecificPowerKPI();

  const infoDataTierSpecificPower = (
    <EPTierProtection componentName={ComponentTierName.MapView}>
      <span className="tier-span">
        <EPTierInfoIcon
          type={SensorsPackage.SpecificPower}
          tooltipTitle={t('isCalculated', { metric: t('Specific Power') })}
          tooltipTextPart1={t('toRecord', { field: 'performance' })}
          tooltipTextPart2={t('getSensorPackage')}
          emailRequestTypeOfInterestedPackage={interestedPackageEnum.SENSOR_PACKAGE}
          emailRequestButtonClicked={'Specific Power tooltip'}
          emailRequestWhichScreen={'Specific Power Side Menu'}
        />
      </span>
    </EPTierProtection>
  );

  const value = tvalue(specificPower, stationStore.isWasteWaterStation ? 'kWh/MG' : 'kW/(m^3/min)');
  return (
    <Container>
      <KPIBox
        title={t('SPECIFIC POWER')}
        value={value}
        unit={
          <div className="tier-wrapper">
            <Trans i18nKey={tunit(stationStore.isWasteWaterStation ? 'kWh/MG' : 'kW/(m3/min)')}>
              <Super />
            </Trans>
            {value !== null && value !== undefined && !Number.isNaN(value) && infoDataTierSpecificPower}
          </div>
        }
        scale={getPredefinedPowerScale(stationStore, tvalue, token)}
        isRelativeScale={false}
        isVertical={true}
        tierLockIsVisible={
          !stationStore.isWasteWaterStation &&
          checkInfoLockTierIsVisible(ComponentTierName.MapView, SensorsPackage.SpecificPower, stationStore)
        }
      />
    </Container>
  );
});
const Container = styled.div`
  padding: 0 ${({ theme: { token } }) => token.padding}px;
  border-radius: 10px;
  text-align: center;
  margin-top: ${({ theme: { token } }) => token.marginXL}px;

  .tier-wrapper {
    display: flex;
    justify-content: center;
  }

  .tier-span {
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    margin-top: ${({ theme: { token } }) => token.marginXXS}px;
  }
`;

export default SpecificPowerCard;
